import type { AgentTodoItem } from './types';

/**
 * Fewest leading completed steps worth folding. Below this the summary row
 * costs about as much height as the steps it hides.
 */
export const PLAN_COLLAPSE_MIN_COMPLETED = 3;

/** Threshold no plan can reach — pass it to show every step. */
export const PLAN_COLLAPSE_DISABLED = Infinity;

export interface CollapsedPlanSteps {
  /** Leading completed steps folded behind the summary row; 0 when expanded. */
  collapsedCount: number;
  visibleItems: readonly AgentTodoItem[];
}

/**
 * Fold the run of completed steps at the head of a plan, leaving the active and
 * upcoming steps in view.
 *
 * A `cancelled` step stops the run so "n done" never counts a dropped step, and
 * a fully completed plan stays expanded rather than folding to a bare row.
 */
export const collapsePlanSteps = (
  items: readonly AgentTodoItem[],
  minCompleted: number = PLAN_COLLAPSE_MIN_COMPLETED
): CollapsedPlanSteps => {
  let leading = 0;
  while (leading < items.length && items[leading]?.status === 'completed') leading += 1;

  if (leading === items.length || leading < minCompleted) {
    return { collapsedCount: 0, visibleItems: items };
  }

  return { collapsedCount: leading, visibleItems: items.slice(leading) };
};
